import { Button, Card, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { useEffect } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';

const TOTAL_FIELD_COUNT = 5;

export default function TrialOrganizationsFilterPanel({ filter, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(TOTAL_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            code: filter.code,
            name: filter.name,
            belongsUnitName: filter.belongsUnitName,
            adminName: filter.adminName,
            state: filter.state,
        });
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Card
            size="small"
            className="healthclass-trial-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="学苑ID" name="code" style={filterFormItemStyle}>
                            <Input allowClear placeholder="学苑ID" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="学苑名称" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="学苑名称" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="管理员" name="adminName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="管理员" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="所属主体" name="belongsUnitName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="所属主体" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="状态" name="state" style={filterFormItemStyle}>
                            <Select allowClear placeholder="请选择">
                                <Select.Option value={1}>正常</Select.Option>
                                <Select.Option value={2}>已停用</Select.Option>
                                <Select.Option value={3}>已取消</Select.Option>
                                <Select.Option value={4}>已过期</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
